import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent {
    title = 'app';

    constructor(router: Router, auth: AuthService) {
        router.events.subscribe((val) => {
            const snap = router.parseUrl(router.url);
            if (snap.queryParams['ccid']) {
                auth.setImpersonationData(Number(snap.queryParams['ccid']), Number(snap.queryParams['suid']));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts